import { z } from "zod";

/** Mirrors backend `GithubIntegrationEntry` in system_settings_models.py. */
export const githubIntegrationSchema = z.object({
  name: z.string().catch(""),
  url: z.string().catch("https://github.com"),
  personal_access_token: z.string().catch(""),
  enabled: z.boolean().catch(true),
});

export type GithubIntegrationEntry = z.infer<typeof githubIntegrationSchema>;

const EMPTY_ENTRY = githubIntegrationSchema.parse({});

export const parseGithubIntegrations = (raw: unknown): GithubIntegrationEntry[] =>
  z.array(githubIntegrationSchema.catch(EMPTY_ENTRY)).catch([]).parse(raw);
